import React from 'react';
import ResponsiveContainer from './layout/ResponsiveContainer';

const AdminTools: React.FC = () => (
  <ResponsiveContainer className="container">
  <div style={{ maxWidth: 700, margin: '40px auto', padding: 32, background: 'white', borderRadius: 16, boxShadow: '0 4px 24px rgba(0,0,0,0.06)' }}>
    <h2 style={{ fontSize: 32, fontWeight: 700, marginBottom: 24 }}>Admin Tools</h2>
    <ul style={{ listStyle: 'none', padding: 0, marginBottom: 24 }}>
      <li style={{ marginBottom: 16, background: '#f3f4f6', borderRadius: 8, padding: 16 }}>
        <strong>Manage Users</strong> - View, edit, or remove users from the platform.
      </li>
      <li style={{ marginBottom: 16, background: '#f3f4f6', borderRadius: 8, padding: 16 }}>
        <strong>Project Oversight</strong> - Monitor active projects and resolve disputes.
      </li>
      <li style={{ marginBottom: 16, background: '#f3f4f6', borderRadius: 8, padding: 16 }}>
        <strong>Site Settings</strong> - Update platform settings and configurations.
      </li>
    </ul>
    <p style={{ color: '#6b7280', fontSize: 16, marginTop: 32 }}>
      <em>This page is for admin management. In production, admins will manage users, projects, and site settings here.</em>
    </p>
  </div>
  </ResponsiveContainer>
);

export default AdminTools; 